<div *ngIf="allowDefaultUnit && isDefaultMode; else unitSelectorInput" class="unit-selector-default">
  <div class="unit-selector-default__copy">
    <span class="unit-selector-default__label">{{ label }}<span *ngIf="required"> *</span></span>
    <strong>{{ defaultUnitName }}</strong>
    <small>{{ defaultHint }}</small>
  </div>

  <button mat-button type="button" (click)="changeUnit()" [disabled]="unitControl.disabled">
    <mat-icon>edit</mat-icon>
    {{ overrideActionLabel }}
  </button>
</div>

<ng-template #unitSelectorInput>
<div class="unit-selector-container" [class.unit-selector-container--compact]="compactStyle" [class.loading]="loading || (isLoading$ | async)">
  <span *ngIf="floatLabel === 'always' && !hideLabel" class="unit-selector-filter-label">{{ label }}</span>
  <mat-progress-bar *ngIf="loading || (isLoading$ | async)" mode="indeterminate" class="loading-bar">
  </mat-progress-bar>
  <mat-form-field [appearance]="appearance ?? 'fill'" [floatLabel]="floatLabel">
    <mat-label *ngIf="floatLabel !== 'always' && !hideLabel">{{ label }}</mat-label>
    <input matInput [attr.aria-label]="label" [formControl]="unitControl" [matAutocomplete]="unitAutocomplete" [required]="required && !multiple"
      [placeholder]="getPlaceholder()" (focus)="onInputFocus()" (input)="onSearchInput()" />
    <button *ngIf="showClearButton && (unitControl.value || (multiple && selectedUnitIds.length)) && !loading && !(isLoading$ | async)" mat-icon-button matSuffix (click)="clearSelection()" type="button"
      [disabled]="unitControl.disabled"
      matTooltip="Limpiar selección">
      <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="allowDefaultUnit && !isDefaultMode && !loading && !(isLoading$ | async)" mat-icon-button matSuffix type="button"
      (click)="useDefaultUnit()" [disabled]="unitControl.disabled" [matTooltip]="defaultActionLabel">
      <mat-icon>undo</mat-icon>
    </button>
    <mat-autocomplete #unitAutocomplete="matAutocomplete" [displayWith]="displayUnitName"
      (optionSelected)="onAutocompleteOptionSelected($event.option.value)">
      <!-- Grouped mode -->
      <ng-container *ngIf="groupByLevel; else flatMode">
        <ng-container *ngIf="filteredGroupedUnits$ | async as groups">
          <ng-container *ngFor="let group of groups">
            <mat-optgroup [label]="group.levelName">
              <mat-option *ngFor="let unit of group.units" [value]="unit.id">
                {{ unit.name }}
                <small *ngIf="showingSuggestions" class="unit-selector-suggestion">Sugerencia</small>
              </mat-option>
            </mat-optgroup>
          </ng-container>
          <mat-optgroup *ngIf="groups.length === 0" label="Sin resultados"></mat-optgroup>
        </ng-container>
      </ng-container>

      <!-- Flat mode (default) -->
      <ng-template #flatMode>
        <ng-container *ngIf="filteredUnits$ | async as units">
          <mat-option *ngFor="let unit of units" [value]="unit.id">
            {{ unit.name }} | <small>{{ unit.levelName }}</small>
            <small *ngIf="showingSuggestions" class="unit-selector-suggestion">Sugerencia</small>
          </mat-option>
          <!-- Mensaje cuando hay pocas opciones por búsqueda corta -->
          <ng-container *ngIf="!isFixedSource">
            <mat-optgroup *ngIf="units.length === 0 && unitControl.value && unitControl.value.length > 0 && unitControl.value.length < minSearchLength" label="Escribe al menos {{ minSearchLength }} caracteres">
            </mat-optgroup>
            <!-- Mensaje cuando no hay resultados para la búsqueda -->
            <mat-optgroup *ngIf="units.length === 0 && unitControl.value && unitControl.value.length >= minSearchLength" label="Sin resultados">
            </mat-optgroup>
          </ng-container>
          <!-- Modo lista fija: sin resultados -->
          <mat-optgroup *ngIf="isFixedSource && units.length === 0" label="Sin resultados">
          </mat-optgroup>
        </ng-container>
      </ng-template>
      <mat-option *ngIf="freeTextCandidate as text" [value]="{ kind: 'text', text: text }">
        Usar «{{ text }}» como {{ freeTextLabel }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="required && unitControl.hasError('required')">
      {{ label }} es requerida
    </mat-error>
    <mat-error *ngIf="unitControl.hasError('invalidUnit')">
      Selecciona una unidad válida de la lista
    </mat-error>
  </mat-form-field>
  <div *ngIf="multiple && selectedUnits.length" class="unit-selector-selections" [attr.aria-label]="label + ' seleccionadas'">
    <span *ngFor="let unit of selectedUnits" class="unit-selector-selection">
      {{ unit.name }}
      <button type="button" (click)="removeUnit(unit.id)" [disabled]="unitControl.disabled" [attr.aria-label]="'Quitar ' + unit.name">
        <mat-icon>close</mat-icon>
      </button>
    </span>
  </div>
</div>
</ng-template>
